import { useSelectableDataCategoriesQuery } from "../../../../processingActivity/hooks/useSelectableDataCategoriesQuery.ts";
import { getSystemEditQueryKey } from "../../../../system/systemEdit/SystemEdit.hooks.ts";
import { deleteHttp, post } from "../../../../common/api/apiShared.ts";
import { useState } from "react";
import { DataCategoryDataTypesSaveModel } from "../../../../processingActivity/ProcessingActivity.types.ts";
import { SystemModel } from "../../../../system/systemEdit/SystemEdit.types.ts";
import { useDotLegalQueryClient, useDotLegalMutation } from "../../../../common/hooks/dotLegalReactQuery.ts";

export interface UseSystemDataCategoriesProps {
    systemViewModel: SystemModel | undefined;
    systemId: string;
    isPreview: boolean;
}

export function useSystemDataCategoriesField(props: UseSystemDataCategoriesProps) {
    const dataCategories = props.systemViewModel?.systemPersonalData?.dataCategories ?? [];

    const queryClient = useDotLegalQueryClient();
    const queryKey = getSystemEditQueryKey(props.systemId);

    const [showDataCategoryDialog, setShowDataCategoryDialog] = useState<string | undefined>(undefined);

    let { isLoading, allDataCategories } = useSelectableDataCategoriesQuery(!props.isPreview);

    function handleChange(isSelected: boolean, dataCategoryDataTypes: DataCategoryDataTypesSaveModel) {
        if (isSelected) {
            addDataCategory(dataCategoryDataTypes.dataCategoryId);
        } else {
            removeDataCategory(dataCategoryDataTypes.dataCategoryId);
        }
    }

    const addDataCategory = (dataCategoryId: string) => {
        const tempDataCategories = [...dataCategories];
        const tempViewModel = { ...props.systemViewModel };
        tempDataCategories.push({ dataCategoryId: dataCategoryId, isSystemSelected: true, processingActivities: [], processingActivitiesWithoutAccess: null });
        tempViewModel.systemPersonalData!.dataCategories = tempDataCategories;
        queryClient.setQueryData(queryKey, props.systemViewModel);
        saveMutation.mutateAsync(dataCategoryId);
    };

    const removeDataCategory = (dataCategoryId: string) => {
        const tempViewModel = { ...props.systemViewModel };
        const tempDataCategories = dataCategories.filter((x) => x.dataCategoryId !== dataCategoryId);
        tempViewModel!.systemPersonalData!.dataCategories = tempDataCategories;
        queryClient.setQueryData(queryKey, props.systemViewModel);
        deleteMutation.mutateAsync(dataCategoryId);
    };

    const saveMutation = useDotLegalMutation(save, {
        onSuccess: () => {},
    });

    function save(dataCategoryId: string) {
        return post("/system/dataCategory", { systemId: props.systemId, dataCategoryId: dataCategoryId });
    }

    const deleteMutation = useDotLegalMutation(remove, {
        onSuccess: () => {},
    });

    function remove(dataCategoryId: string) {
        return deleteHttp(`/system/${props.systemId}/${dataCategoryId}/dataCategory`);
    }

    return { isLoading, allDataCategories, dataCategories, handleChange, showDataCategoryDialog, setShowDataCategoryDialog };
}
